import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import TransctionsReport from "../TransctionsReport";
import Factor from "./Factor";
import Tafsil from './Tafsil';
import WorkFlowStepLogging from "../BPMS/WorkFlowStepLogging";

export default class Document extends Base {
    constructor(props) {
        super(props);
        this.state = {
            enableDatePicker: false,
            isTemplate: (this.isNull(props.IsTemplate) ? false : props.IsTemplate),
            caller: props.Caller,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            orderingId: this.isNull(props.OrderingId) ? this.defaultGuid() : props.OrderingId,
            controllerName: 'document',
            data: null,
            loading: true,
            t_bed: 0,
            t_bes: 0,
            templateId: null,

            buildingId: null,
            buildingTitle: null,
            unitId: null,
            unitTitle: null,
            billExpenseUnitTitle: null,
        };
        this.inputRefs = [];
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    resetRefs() {
        this.inputRefs = [];
    }
    handleKeyDown = (rowIndex, colIndex, e) => {
        const row = this.inputRefs[rowIndex];
        const colCount = row.length;
        const rowCount = this.inputRefs.length;

        if (colCount <= colIndex && rowCount <= rowIndex) return;

        if (e.key === "Enter") {
            e.preventDefault();
            if (colIndex + 1 < colCount) {
                //find first next active input
                if (!row[colIndex + 1]) {
                    this.handleKeyDown(rowIndex, colIndex + 1, e);
                }
                else {
                    row[colIndex + 1]?.focus();
                    if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
                }
            } else if (rowIndex + 1 < rowCount) {
                if (!this.inputRefs[rowIndex + 1][0]) {
                    this.handleKeyDown(rowIndex + 1, 1, e);
                }
                else {
                    this.inputRefs[rowIndex + 1][0]?.focus();
                    if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
                }
            }
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();
            e.preventDefault();
            if (rowIndex + 1 < rowCount) {
                this.inputRefs[rowIndex + 1][colIndex]?.focus();
                if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
            }
        }

        if (e.key === "ArrowUp") {
            e.preventDefault();
            if (rowIndex - 1 >= 0) {
                this.inputRefs[rowIndex - 1][colIndex]?.focus();
                if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
            }
        }
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/document/get", {
            id: this.state.id,
            isTemplate: this.state.isTemplate,
            loadFromTemplate: false,
            orderingId: this.state.orderingId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;

                    //this.state.unitTitle = data.unitTitle;
                    this.state.billExpenseUnitTitle = data.billExpenseUnitTitle;
                    //this.state.buildingTitle = data.buildingTitle;

                    this.state.data = data;
                    this.state.loading = false;
                    this.updateFormula();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showAccoutTransactions(id) {
        this.removeKeyDown();
        this.showComponents({ component: <TransctionsReport Caller={this} Id={id} IsPopup={true} /> });
    }
    showFactor(id, type) {
        this.removeKeyDown();
        this.showComponents({
            component: <Factor Type={type} Caller={this} Id={id} RefreshCallerAfterSave={false} />
        });
    }
    save(e, stateInForm = false) {
        if (!this.isNull(e)) e.preventDefault();
        var bodies = [];

        this.state.data.bodies.forEach(i => {
            var clone = Object.assign({}, i);
            clone.followDate = this.convertMomentToDb(clone.followDate);
            bodies.push(clone);
        });

        if (this.isBlank(this.state.data.subNumber)) this.state.data.subNumber = 0;

        this.httpPost("api/v1/document/save", {
            id: this.state.id,
            isTemplate: this.state.isTemplate,
            subNumber: this.state.data.record.subNumber,
            title: this.state.data.record.title,
            source: this.state.data.record.source,
            organizationId: this.state.data.global.company.id,
            documentTypeId: this.state.data.record.documentTypeId,
            description: this.state.data.record.description,
            date: (this.state.enableDatePicker === true ? this.convertMomentToDb(this.state.data.record.date) : this.state.data.record.dateString),
            note: this.state.data.record.note,
            status: this.state.data.record.status,
            type: this.state.data.record.type,
            billExpenseUnitId: this.state.data.record.billExpenseUnitId,
            orderingId: this.state.data.record.orderingId,
            bodies: bodies,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("سند با موفقیت ذخیره شد");
                    if (!stateInForm) {
                        this.state.caller.refreshData(null, "list", "json", (this.state.id === this.getDefaultGuid() ? true : false));
                        this.closeMe();
                    }
                    else {
                        this.state.id = data.record.id;
                        this.getData();
                    }
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setBodyValue(id, field, value, rowIndex = 0, columnIndex = 0) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                if (field == 'moeinAccountId' || field == 'solutionId') {
                    if (field == 'moeinAccountId') {
                        this.state.data.bodies[i]['moeinName'] = value.label;
                        this.state.data.bodies[i]['moeinAccountId'] = value.id;
                        this.state.data.bodies[i][field] = value.value;

                        if (!this.validToChequePass(this.state.data.bodies[i].moeinAccountId)) {
                            this.state.data.bodies[i].chequeInfoId = null;
                            this.state.data.bodies[i].chequeInfoNumber = '';
                        }
                    }
                    if (field == 'solutionId') {
                        this.state.data.bodies[i]['solutionName'] = value.label;
                        this.state.data.bodies[i]['solutionId'] = value.value;
                    }
                }
                else {
                    this.state.data.bodies[i][field] = value;
                }

                if (field == 'moeinAccountId') {
                    this.state.data.bodies[i]['moeinDetailed'] = value.moeinDetailed;
                    this.state.data.bodies[i]['moeinFollow'] = value.moeinFollow;
                    this.state.data.bodies[i]['moeinCurrency'] = value.moeinCurrency;
                    this.state.data.bodies[i]['moeinCounting'] = value.moeinCounting;
                    this.state.data.bodies[i]['moeinSolutionMostSelect'] = value.moeinSolutionMostSelect;
					
                    if (!value.moeinDetailed) {
                        this.state.data.bodies[i]['tafsilAccountId'] = this.getDefaultGuid();
                        this.state.data.bodies[i]['tafsilName'] = '';
                        this.state.data.bodies[i]['accountTafsilType'] = -1;

                        this.state.data.bodies[i]['tafsilAccountId2'] = this.getDefaultGuid();
                        this.state.data.bodies[i]['tafsilName2'] = '';
                        this.state.data.bodies[i]['accountTafsilType2'] = -1;
                    }
                }

                if (this.isBlank(this.state.data.bodies[i]["bed"])) this.state.data.bodies[i]["bed"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["bes"])) this.state.data.bodies[i]["bes"] = 0;
            }
        }

        this.updateFormula();

        //handle enter key op
        if (field == 'moeinAccountId' || field == 'solutionId') {
                setTimeout(() => {
					this.doEnterAfterSelect(rowIndex, columnIndex);
				}, 50);
        }
    }
    doEnterAfterSelect(rowIndex, colIndex) {
        const row = this.inputRefs[rowIndex];
        const colCount = row.length;
        const rowCount = this.inputRefs.length;

        if (colCount <= colIndex && rowCount <= rowIndex) return;

        if (colIndex + 1 < colCount) {
            //find first next active input
            if (!row[colIndex + 1]) {
                this.doEnterAfterSelect(rowIndex, colIndex + 1);
            }
            else {
                row[colIndex + 1]?.focus();
                if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
            }
        } else if (rowIndex + 1 < rowCount) {
            if (!this.inputRefs[rowIndex + 1][0]) {
                this.doEnterAfterSelect(rowIndex + 1, 1);
            }
            else {
                this.inputRefs[rowIndex + 1][0]?.focus();
                if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
            }
        }
    }
    updateFormula() {
        this.state.t_bed = 0;
        this.state.t_bes = 0;
        var hasBlankRow = false;
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].moeinAccountId === this.getDefaultGuid()) hasBlankRow = true;

            this.state.t_bed = this.FixedPointNumber(this.state.data.bodies[i]["bed"] + this.state.t_bed);
            this.state.t_bes = this.FixedPointNumber(this.state.data.bodies[i]["bes"] + this.state.t_bes);
        }
        if (!hasBlankRow) this.addBlankRow();

        this.setState({ date: this.state.data });
    }
    addBlankRow() {
        this.state.data.bodies.push(this.getBlankRow());
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            chequeInfoId: null,
            chequeInfoNumber: '',
            moeinAccountId: this.getDefaultGuid(),
            tafsilAccountId: this.getDefaultGuid(),
            tafsilAccountId2: this.getDefaultGuid(),
            index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
            moeinName: '',
            tafsilAccountId: 0,
            accountTafsilType: -1,
            tafsilName: '',
            accountTafsilType2: -1,
            tafsilName2: '',
            bed: 0,
            bes: 0,
            description: '',
            followNumber: '',
            followDate: null,
            count: 0,
            currencyId: this.getDefaultGuid(),
            currencyAmount: 0,
            currencyRate: 0,
            solutionId: this.getDefaultGuid(),
            solutionName: '',
            moeinDetailed: false,
            moeinFollow: false,
            moeinCurrency: false,
            moeinCounting: false,
            moeinSolutionMostSelect: false
        }
    }
    removeRow(id) {
        this.resetRefs();
        var temp = [];
        var index = 1;
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id != id) {
                temp.push(r);
                temp[temp.length - 1].index = index;
                index++;
            }
        });
        this.state.data.bodies = temp;
        this.updateFormula();
    }
    copyRow(id) {
        this.resetRefs();
        var clone = null;
        this.state.data.bodies.forEach(i => {
            if (i.id === id) {
                clone = Object.assign({}, i);
            }
        });
        clone.id = this.uuidv4();
        var startIndex = clone.index;
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].index > startIndex) this.state.data.bodies[i].index++;
        }
        clone.index++;
        this.state.data.bodies.push(clone);
        this.updateFormula();
    }
    upIndex(id) {
        this.resetRefs();
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex > 0) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii - 1;
            this.state.data.bodies[idIndex - 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        this.resetRefs();
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex < this.state.data.bodies.length - 1) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii + 1;
            this.state.data.bodies[idIndex + 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    setTemplate(e) {
        this.state.templateId = e.value;
        this.httpPost("api/v1/document/get", {
            id: this.state.templateId,
            isTemplate: false,
            loadFromTemplate: true,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.state.data = data;
                    this.state.loading = false;
                    this.updateFormula();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    nextDocument() {
        if (this.isNull(this.state.data.nextDocumentId)) return;

        this.state.id = this.state.data.nextDocumentId;
        this.getData();
    }
    previewsDocument() {
        if (this.isNull(this.state.data.previewsDocumentId)) return;

        this.state.id = this.state.data.previewsDocumentId;
        this.getData();
    }
    handleChange = (e) => {
        const { name, value } = e.target;

        var _value = value;
        if (name === 'subNumber') _value = parseInt(_value);

        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                record: {
                    ...prevState.data.record,
                    [name]: _value
                }
            }
        }));
    }
    setTafsil(e, id, rowIndex = 0, columnIndex = 0) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                this.state.data.bodies[i]['tafsilAccountVersion'] = this.uuidv4();
                if (e == null) {                    
                    this.state.data.bodies[i]['tafsilName'] = '';
                    this.state.data.bodies[i]['accountTafsilType'] = -1;
                    this.state.data.bodies[i]['tafsilAccountId'] = this.getDefaultGuid();
                }
                else {

                    if (e.value == -1) {

                        this.state.data.bodies[i]['tafsilName'] = '';
                        this.state.data.bodies[i]['accountTafsilType'] = -1;
                        this.state.data.bodies[i]['tafsilAccountId'] = this.getDefaultGuid();

                        this.showComponents({
                            component: <Tafsil Caller={this} FromAutoComplete={true} CallbackData={{ bodyId: id }} />
                        });
                        return;
                    }

                    this.state.data.bodies[i]['tafsilAccountId'] = e.value;
                    this.state.data.bodies[i]['tafsilName'] = e.label;
                    this.state.data.bodies[i]['accountTafsilType'] = e.accountTafsilType;
                }
            }
        }
        this.updateFormula();

        //handle enter key op
        this.doEnterAfterSelect(rowIndex, columnIndex);
    }
    setTafsil2(e, id, rowIndex = 0, columnIndex = 0) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                this.state.data.bodies[i]['tafsilAccountVersion2'] = this.uuidv4();
                if (e == null) {
                    this.state.data.bodies[i]['tafsilName2'] = '';
                    this.state.data.bodies[i]['accountTafsilType2'] = -1;
                    this.state.data.bodies[i]['tafsilAccountId2'] = this.getDefaultGuid();
                }
                else {

                    if (e.value == -1) {

                        this.state.data.bodies[i]['tafsilName2'] = '';
                        this.state.data.bodies[i]['accountTafsilType2'] = -1;
                        this.state.data.bodies[i]['tafsilAccountId2'] = this.getDefaultGuid();

                        this.showComponents({
                            component: <Tafsil Caller={this} FromAutoComplete={true} CallbackData={{ bodyId: id }} />
                        });
                        return;
                    }

                    this.state.data.bodies[i]['tafsilName2'] = e.label;
                    this.state.data.bodies[i]['tafsilAccountId2'] = e.value;
                    this.state.data.bodies[i]['accountTafsilType2'] = e.accountTafsilType;
                }
            }
        }
        this.updateFormula();

        //handle enter key op
        this.doEnterAfterSelect(rowIndex, columnIndex);
    }
    setChequeInfoId(e, id, rowIndex = 0, columnIndex = 0) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                this.state.data.bodies[i]['chequeInfoVersion2'] = this.uuidv4();
                if (e == null) {
                    this.state.data.bodies[i]['chequeInfoNumber'] = '';
                    this.state.data.bodies[i]['chequeInfoId'] = null;
                }
                else {
                    this.state.data.bodies[i]['chequeInfoNumber'] = e.label;
                    this.state.data.bodies[i]['chequeInfoId'] = e.value;
                }
            }
        }
        this.updateFormula();

        //handle enter key op
        this.doEnterAfterSelect(rowIndex, columnIndex);
    }
    onEditAccount(id, bodyId, tafsilType) {
        this.showComponents({ component: <Tafsil TafsilType={tafsilType} Caller={this} Id={id} FromAutoComplete={true} CallbackData={{ bodyId: bodyId }} /> });
    }
    //override
    remove() {
        var id = this.state.id_to_remove;
        if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

        this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
            id,
            companyId: this.state.data.global.company.id,
            organizationId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({ showConfirmRemove: false });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    //setBuilding(e) {
    //    this.state.unitId = null
    //    this.state.data.record.billExpenseUnitId = null
    //    this.setState({ buildingId: e.value, buildingTitle: e.label });
    //}
    //setUnit(e) {
    //    this.state.data.record.billExpenseUnitId = null
    //    this.setState({ unitId: e.value, unitTitle: e.label });
    //}
    setUnitBillExponse(e) {
        if (this.isNull(e)) {
            this.state.data.record.billExpenseUnitId = this.getDefaultGuid();
            this.state.data.record.billExpenseUnitTitle = '';
        } else {
            this.state.data.record.billExpenseUnitId = e.value;
            this.state.data.record.billExpenseUnitTitle = e.label;
        }
        this.setState({ data: this.state.data });
    }
	
    validToChequePass(moeinId) {
        return (moeinId === this.state.data.pardakhtaniDocsMoin ||
            moeinId === this.state.data.cheqeueDarJaryanVosolMoin ||
            moeinId === this.state.data.daryaftaniDocsMoin);
    }
    getChequeType(moeinId) {
        if (moeinId === this.state.data.cheqeueDarJaryanVosolMoin ||
            moeinId === this.state.data.daryaftaniDocsMoin) return 1;

        if (moeinId === this.state.data.pardakhtaniDocsMoin) return 2;

        return null;
    }
    renderBody() {
        var trs = [];
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach((item, index) => {
            var tds = [];
            var refColumnIndex = 0;

            tds.push(<td>
                <span>{(index + 1)}</span>
                <div style={{
                    "font-size": "9pt", "color": "silver"
                }}>
                    {index > 0 && index != this.state.data.bodies.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
                    {index < this.state.data.bodies.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
                </div>
            </td>);

            tds.push(<td>
                {item.moeinAccountId !== this.getDefaultGuid() && <span onClick={e => this.showAccoutTransactions(item.moeinAccountId)} className="fa fa-list" title="مشاهده تراکنش ها"></span>}
            </td>);

            let _refColumnIndexC1 = refColumnIndex;
            tds.push(<td>
                <span className="onlyMobile">معین: </span>
                <SelectAsync
                    style={{ "width": "100%" }}
                    defaultValue={item.moeinAccountId !== this.getDefaultGuid() ? [{ value: item.moeinAccountId, label: item.moeinName }] : null}
                    isMulti={false}
                    placeholder="انتخاب حساب معین"
                    noOptionsMessage={({ inputValue }) =>
                        inputValue ? "نتیجه‌ای یافت نشد" : null
                    }
                    defaultOptions={[]}
                    components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                    }}
                    loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3)}
                    onChange={(e) =>
                        this.setBodyValue(item.id, 'moeinAccountId', e, index, _refColumnIndexC1)
                    }
                    ref={(el) => {
                        if (!this.inputRefs[index])
                            this.inputRefs[index] = [];
                        this.inputRefs[index][_refColumnIndexC1] = el;
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                            const select = this.inputRefs[index][_refColumnIndexC1];
                            if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC1, e);
                        }
                    }}
                />
            </td>);
            refColumnIndex++;

            tds.push(<td>
                {item.moeinDetailed && [
                    item.tafsilAccountId !== this.getDefaultGuid() > 0 && <span onClick={e => this.showAccoutTransactions(item.tafsilAccountId)} className="fa fa-list" title="مشاهده تراکنش ها"></span>,
                    <em className="icon ni ni-plus hand ms-1" onClick={e => this.setTafsil({ value: -1 }, item.id)}></em>,
                    !this.isNull(item.tafsilAccountId) && item.tafsilAccountId != this.defaultGuid() && <em onClick={e => this.onEditAccount(item.tafsilAccountId, item.id, item.accountTafsilType)} className="icon ni ni-pen hand ms-1"></em>
                ]}
            </td>);

            let _refColumnIndexC3 = refColumnIndex;
            tds.push(<td key={"tafsil_" + (item.tafsilAccountVersion ? item.tafsilAccountVersion : item.tafsilAccountId)}>
                <span className="onlyMobile">تفصیلی: </span>
                {item.moeinDetailed &&
                    <SelectAsync
                        style={{ "width": "100%" }}
                        defaultValue={item.tafsilAccountId !== this.getDefaultGuid() ? [{ value: item.tafsilAccountId, label: item.tafsilName }] : null}
                        isMulti={false}
                        isClearable={true}
                        placeholder="انتخاب حساب تفصیل"
                        noOptionsMessage={({ inputValue }) =>
                            inputValue ? "نتیجه‌ای یافت نشد" : null
                        }
                        defaultOptions={[]}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, 0, 1, item.tafsilAccountId2)}
                        onChange={e => this.setTafsil(e, item.id, index, _refColumnIndexC3)}
                        ref={(el) => {
                            if (!this.inputRefs[index])
                                this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC3] = el;
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                                const select = this.inputRefs[index][_refColumnIndexC3];
                                if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC3, e);
                            }
                        }}
                    />
                }
            </td>);
            refColumnIndex++;

            if (this.state.data.global.company.documentTafsilCount > 1) {
                tds.push(<td>
                    {item.moeinDetailed && [
                        item.tafsilAccountId2 !== this.getDefaultGuid() && <span onClick={e => this.showAccoutTransactions(item.tafsilAccountId2)} className="fa fa-list" title="مشاهده تراکنش ها"></span>,
                        <em className="icon ni ni-plus hand ms-1" onClick={e => this.setTafsil2({ value: -1 }, item.id)}></em>,
                        !this.isNull(item.tafsilAccountId2) && item.tafsilAccountId2 != this.defaultGuid() && <em onClick={e => this.onEditAccount(item.tafsilAccountId2, item.id, item.accountTafsilType2)} className="icon ni ni-pen hand ms-1"></em>
                    ]}
                </td>);
            }

            if (this.state.data.global.company.documentTafsilCount > 1) {
                let _refColumnIndexC5 = refColumnIndex;
                tds.push(<td key={"tafsil2_" + (item.tafsilAccountVersion2 ? item.tafsilAccountVersion2 : item.tafsilAccountId2)}>
                    {item.moeinDetailed && (
                        <SelectAsync
                            style={{ width: '100%' }}
                            defaultValue={
                                item.tafsilAccountId2 !== this.getDefaultGuid()
                                    ? [
                                        {
                                            value: item.tafsilAccountId2,
                                            label: item.tafsilName2,
                                        },
                                    ]
                                    : null
                            }
                            isMulti={false}
                            isClearable={true}
                            placeholder="انتخاب حساب تفصیل"
                            noOptionsMessage={({ inputValue }) =>
                                inputValue ? "نتیجه‌ای یافت نشد" : null
                            }
                            defaultOptions={[]}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, 0, 1, item.tafsilAccountId)}
                            onChange={e => this.setTafsil2(e, item.id, index, _refColumnIndexC5)}
                            ref={(el) => {
                                if (!this.inputRefs[index])
                                    this.inputRefs[index] = [];
                                this.inputRefs[index][_refColumnIndexC5] = el;
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                                    const select = this.inputRefs[index][_refColumnIndexC5];
                                    if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC5, e);
                                }
                            }}
                        />
                    )}
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.global.company.documentItemSolution === true) {
                let _refColumnIndexC6 = refColumnIndex;
                tds.push(<td>
                    <span className="onlyMobile">پروژه: </span>
                    {item.moeinSolutionMostSelect && <SelectAsync
                        style={{ "width": "100%" }}
                        defaultValue={item.solutionId !== this.getDefaultGuid() ? [{ value: item.solutionId, label: item.solutionName }] : null}
                        isMulti={false}
                        placeholder="جستجو و انتخاب پروژه"
                        noOptionsMessage={({ inputValue }) =>
                            inputValue ? "نتیجه‌ای یافت نشد" : null
                        }
                        defaultOptions={[]}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        loadOptions={(inputValue, callback) => this.loadSolutionsOptions(inputValue, callback)}
                        onChange={e => this.setBodyValue(item.id, 'solutionId', e, index, _refColumnIndexC6)
                        }
                        ref={(el) => {
                            if (!this.inputRefs[index])
                                this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC6] = el;
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
                                const select = this.inputRefs[index][_refColumnIndexC6];
                                if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC6, e);
                            }
                        }}
                    />}
                </td>);
                refColumnIndex++;
            }

            let _refColumnIndexC7 = refColumnIndex;
            tds.push(<td>
                <span className="onlyMobile">شرح: </span>
                <input onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} defaultValue={item.description} autocomplete="off" type="text"
                    className="form-control p-0 text-center"
                    ref={(el) => {
                        if (!this.inputRefs[index])
                            this.inputRefs[index] = [];
                        this.inputRefs[index][_refColumnIndexC7] = el;
                    }}
                    onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC7, e)}
                />
            </td>);
            refColumnIndex++;

            let _refColumnIndexC8 = refColumnIndex;
            tds.push(<td style={{ "width": "100px" }}>
                <span className="onlyMobile">بدهکار: </span>
                <NumberFormat value={item.bed} onChange={e => this.setBodyValue(item.id, 'bed', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''}
                    className='form-control p-0 text-center'
                    getInputRef={(el) => {
                        if (!this.inputRefs[index]) this.inputRefs[index] = [];
                        this.inputRefs[index][_refColumnIndexC8] = el;
                    }}
                    onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC8, e)}
                />
            </td>);
            refColumnIndex++;

            let _refColumnIndexC9 = refColumnIndex;
            tds.push(<td style={{ "width": "100px" }}>
                <span className="onlyMobile">بستانکار: </span>
                <NumberFormat value={item.bes} onChange={e => this.setBodyValue(item.id, 'bes', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''}
                    className='form-control p-0 text-center'
                    getInputRef={(el) => {
                        if (!this.inputRefs[index]) this.inputRefs[index] = [];
                        this.inputRefs[index][_refColumnIndexC9] = el;
                    }}
                    onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC9, e)}
                />
            </td>);
            refColumnIndex++;

            if (this.state.data.record.automatic === false && this.validToChequePass(item.moeinAccountId)) {
				let _refColumnIndexC16 = refColumnIndex;
				tds.push(<td key={"chequeInfo_" + (item.chequeInfoVersion2 ? item.chequeInfoVersion2 : item.chequeInfoId)}>
					{item.moeinDetailed && (
						<SelectAsync
							style={{ width: '100%' }}
							defaultValue={
								item.chequeInfoId !== null
									? [
										{
											value: item.chequeInfoId,
											label: item.chequeInfoNumber,
										},
									]
									: null
							}
							isMulti={false}
							isClearable={true}
							placeholder="انتخاب چک"
							noOptionsMessage={({ inputValue }) =>
								inputValue ? "نتیجه‌ای یافت نشد" : null
							}
							defaultOptions={[]}
							components={{
								DropdownIndicator: () => null,
								IndicatorSeparator: () => null,
							}}
							loadOptions={(inputValue, callback) => this.loadChequeInfosOptions(inputValue, callback,this.getChequeType(item.moeinAccountId),1)}
							onChange={e => this.setChequeInfoId(e, item.id, index, _refColumnIndexC16)}
							ref={(el) => {
								if (!this.inputRefs[index])
									this.inputRefs[index] = [];
								this.inputRefs[index][_refColumnIndexC16] = el;
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === "ArrowDown" || e.key === "ArrowUp") {
									const select = this.inputRefs[index][_refColumnIndexC16];
									if (this.isNull(select.state.focusedOptionId)) this.handleKeyDown(index, _refColumnIndexC16, e);
								}
							}}
						/>
					)}
				</td>);
				refColumnIndex++;
			}			
            else {
                tds.push(<td><span>{item.chequeInfoNumber}</span></td>)
            }
			
            if (this.state.data.companySettings.documentItemCount) {
                let _refColumnIndexC10 = refColumnIndex;
                tds.push(<td style={{ "width": "60px" }}>
                    <span className="onlyMobile">تعداد: </span>
                    {item.moeinCounting && <NumberFormat value={item.count}
                        onChange={e => this.setBodyValue(item.id, 'count', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''}
                        className='form-control p-0 text-center'
                        getInputRef={(el) => {
                            if (!this.inputRefs[index]) this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC10] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC10, e)}
                    />}
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.companySettings.documentItemRefNumber) {
                let _refColumnIndexC11 = refColumnIndex;
                tds.push(<td style={{ "width": "80px" }}>
                    <span className="onlyMobile">شماره پیگیری: </span>
                    {item.moeinFollow && <input type="text" defaultValue={item.followNumber}
                        onChange={e => this.setBodyValue(item.id, 'followNumber', e.target.value)}
                        className='form-control p-0 text-center'
                        ref={(el) => {
                            if (!this.inputRefs[index])
                                this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC11] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC11, e)}
                    />}
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.companySettings.documentItemRefDate) {
                let _refColumnIndexC12 = refColumnIndex;
                tds.push(<td style={{ "width": "80px" }}>
                    <span className="onlyMobile">تاریخ پیگیری: </span>
                    {item.moeinFollow && <DatePicker
                        inputReadOnly={true}
                        className="form-control persian-date"
                        placeholder={"تاریخ"}
                        isGregorian={false}
                        showTodayButton={true}
                        timePicker={false}
                        onChange={(e) => { this.setBodyValue(item.id, 'followDate', e) }}
                        value={this.getFormatedDateForDatePicker(item.followDate)}
                        ref={(el) => {
                            if (!this.inputRefs[index])
                                this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC12] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC12, e)}
                    />
                    }
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.companySettings.documentItemCurrencyPrice) {
                let _refColumnIndexC13 = refColumnIndex;
                tds.push(<td style={{ "width": "80px" }}>
                    <span className="onlyMobile">مبلغ ارز: </span>
                    {item.moeinCurrency && <NumberFormat value={item.currencyAmount}
                        onChange={e => this.setBodyValue(item.id, 'currencyAmount', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''}
                        className='form-control p-0 text-center'
                        getInputRef={(el) => {
                            if (!this.inputRefs[index]) this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC13] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC13, e)}
                    />}
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.companySettings.documentItemCurrencyRate) {
                let _refColumnIndexC14 = refColumnIndex;
                tds.push(<td style={{ "width": "80px" }}>
                    <span className="onlyMobile">نرخ ارز: </span>
                    {item.moeinCurrency && <NumberFormat value={item.currencyRate}
                        onChange={e => this.setBodyValue(item.id, 'currencyRate', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''}
                        className='form-control p-0 text-center'
                        getInputRef={(el) => {
                            if (!this.inputRefs[index]) this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC14] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC14, e)}
                    />
                    }
                </td>);
                refColumnIndex++;
            }

            if (this.state.data.companySettings.documentItemCurrency) {
                let _refColumnIndexC15 = refColumnIndex;
                tds.push(<td style={{ "width": "70px" }}>
                    <span className="onlyMobile">ارز: </span>
                    {item.moeinCurrency && <select defaultValue={item.currencyId} onChange={e => this.setBodyValue(item.id, 'currencyId', e.target.value)} className='form-control p-0 text-center'
                        ref={(el) => {
                            if (!this.inputRefs[index])
                                this.inputRefs[index] = [];
                            this.inputRefs[index][_refColumnIndexC15] = el;
                        }}
                        onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC15, e)}>
                        <option value={this.getDefaultGuid()}>انتخاب</option>
                        {this.state.data.currencies.map(currency => <option value={currency.id}>{currency.name}</option>)}
                    </select>}
                </td>);
                refColumnIndex++;
            }

            tds.push(<td>
                {item.moeinAccountId !== this.getDefaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
                {item.moeinAccountId !== this.getDefaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
            </td>);

            trs.push(<tr key={item.id}>{tds}</tr>);
        });
        return <tbody>{trs}</tbody>
    }
    renderForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" id="DocumentModalViewerContent">
                        <div className="panel panel-info center-block" style={{ "max-width": " none" }}>
                            <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                                <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">سند حسابداری</h4>
                            </div>
                            <div className="modal-body">
                                {!this.state.isTemplate && this.state.data.record.id === this.defaultGuid() && this.state.templateId === null && <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">فراخوانی الگوی سند</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={null}
                                                    isMulti={false}
                                                    placeholder="انتخاب الگو"
                                                    noOptionsMessage={({ inputValue }) =>
                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                    }
                                                    defaultOptions={[]}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    loadOptions={this.loadDocumentTemplatesOptions}
                                                    onChange={e => this.setTemplate(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                <div className="row">
                                    {!this.state.isTemplate && 
                                        this.state.data.global.company.mainBussinessType === 4 && [
                                        //    <div className="col-sm-3 mb-2">
                                        //        <div className="form-group">
                                        //            <label>انتخاب ساختمان</label>
                                        //            <SelectAsync
                                        //                isMulti={false}
                                        //                placeholder="انتخاب ساختمان"
                                        //                defaultOptions
                                        //                loadOptions={(inputValue, callback) => this.loadBuildingsOptions(inputValue, callback)}
                                        //                onChange={e => this.setBuilding(e)}
                                        //            />
                                        //        </div>
                                        //</div>,
                                        //<div className="col-sm-3 mb-2">
                                        //    <div className="form-group">
                                        //        <label>انتخاب واحد ساختمان</label>
                                        //        <SelectAsync
                                        //            isMulti={false}
                                        //            placeholder="انتخاب واحد ساختمان"
                                        //            defaultOptions
                                        //            loadOptions={(inputValue, callback) => this.loadBuildingUnitsOptions(inputValue, callback, this.state.buildingId, 0)}
                                        //            onChange={e => this.setUnit(e)}
                                        //        />
                                        //    </div>
                                        //</div>,
                                        //this.state.unitId !== null &&
                                        /*<div className="col-sm-6 mb-2" key={this.state.unitId}>*/
                                        <div className="col-sm-12 mb-2">
                                                <div className="form-group">
                                                    <label>موضوع صورتحساب</label>
                                                    <SelectAsync
                                                        isClearable={true}
                                                        defaultValue={this.state.data.record.billExpenseUnitId == this.getDefaultGuid() ? null : [{ value: this.state.data.record.billExpenseUnitId, label: this.state.billExpenseUnitTitle }]}
                                                        isMulti={false}
                                                        placeholder="موضوع صورتحساب"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadBillExpenseUnitsOptions(inputValue, callback, this.state.buildingId, 0, this.state.unitId, false)}
                                                        onChange={e => this.setUnitBillExponse(e)}
                                                    />
                                                </div>
                                            </div>
                                        ]}

                                    {this.state.isTemplate && <div className="col-sm-8">
                                        <div className="form-group">
                                            <label className="title1">عنوان</label>
                                            <input
                                                name="title"
                                                value={this.state.data.record.title}
                                                onChange={this.handleChange}
                                                autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>}
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">شرح</label>
                                            <input
                                                name="description"
                                                value={this.state.data.record.description}
                                                onChange={this.handleChange}
                                                autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    {!this.state.isTemplate && <div className="col-sm-1">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تاریخ<span className="red">*</span></label>
                                            {this.state.enableDatePicker === true ? <DatePicker
                                                inputReadOnly={false}
                                                className="form-control persian-date ltr"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.date = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                            /> :
                                                <input
                                                    onChange={(e) => this.state.data.record.date = e.target.value}
                                                    defaultValue={this.state.data.record.date}
                                                    autoComplete="off"
                                                    placeholder={'تاریخ'}
                                                    type="text"
                                                    className="form-control ltr"
                                                    maxLength="10"
                                                />}
                                        </div>
                                    </div>}
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="title1">نوع</label>
                                            <select
                                                name="documentTypeId"
                                                value={this.state.data.record.documentTypeId}
                                                onChange={this.handleChange}
                                                className='form-control'>
                                                <option value={this.getDefaultGuid()}>انتخاب</option>
                                                {this.state.data.types.map(currency => <option value={currency.id}>{currency.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    {!this.state.isTemplate && this.hasPermission(226) && <div className="col-sm-1">
                                        <div className="form-group">
                                            <label className="title1">وضعیت</label>
                                            <select onChange={e => this.state.data.record.status = parseInt(e.target.value)} defaultValue={this.state.data.record.status} autocomplete="off" type="text" className="form-control">
                                                <option value="2">موقت</option>
                                                <option value="3">قطعی</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.data.record !== this.getDefaultGuid() && !this.state.isTemplate && <div className="col-sm-1">
                                        <div className="form-group">
                                            <label className="title1">شماره</label>
                                            <input value={this.state.data.record.number} autocomplete="off" type="text" className="form-control" disabled="disabled" />
                                        </div>
                                    </div>}
                                    {this.state.data.record !== this.getDefaultGuid() && !this.state.isTemplate && <div className="col-sm-1">
                                        <div className="form-group">
                                            <label className="title1">عطف</label>
                                            <input value={this.state.data.record.number2} autocomplete="off" type="text" className="form-control" disabled="disabled" />
                                        </div>
                                    </div>}
                                    {!this.state.isTemplate && <div className="col-sm-1">
                                        <div className="form-group">
                                            <label className="title1">شماره فرعی</label>
                                            <input
                                                name="subNumber"
                                                value={this.state.data.record.subNumber}
                                                onChange={this.handleChange}
                                                autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>}
                                    {this.state.data.record !== this.getDefaultGuid() && !this.state.isTemplate && <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="title1">شماره اختصاصی</label>
                                            <input value={this.state.data.record.typeNumber} autocomplete="off" type="text" className="form-control" disabled="disabled" />
                                        </div>
                                    </div>}
                                </div>
                                <table className="table table-bordered table-hover acc_grid_row">
                                    <thead>
                                        <tr className="active">
                                            <td style={{ "width": "30px" }}>#</td>
                                            <td style={{ "width": "30px" }}></td>
                                            <td>معین</td>
                                            <td style={{ "width": "30px" }}></td>
                                            <td>تفصیل</td>
                                            {this.state.data.global.company.documentTafsilCount > 1 && <td style={{ "width": "30px" }}></td>}
                                            {this.state.data.global.company.documentTafsilCount > 1 && <td>تفصیل 2</td>}
                                            {this.state.data.global.company.documentItemSolution === true && <th>پروژه</th>}
                                            <td>شرح</td>
                                            <td>بدهکار <span style={{ "font-weight": "normal" }} > ({this.state.data.global.company.currencyUnit})</span></td>
                                            <td>بستانکار <span style={{ "font-weight": "normal" }} > ({this.state.data.global.company.currencyUnit})</span></td>
                                            <td>شماره چک</td>
                                            {this.state.data.companySettings.documentItemCount && <td>تعداد</td>}
                                            {this.state.data.companySettings.documentItemRefNumber && <td>شماره پیگیری</td>}
                                            {this.state.data.companySettings.documentItemRefDate && <td>تاریخ پیگیری</td>}
                                            {this.state.data.companySettings.documentItemCurrencyPrice && <td>مبلغ ارز</td>}
                                            {this.state.data.companySettings.documentItemCurrencyRate && <td>نرخ ارز</td>}
                                            {this.state.data.companySettings.documentItemCurrency && <td>ارز</td>}
                                            <td style={{ "width": "35px" }}></td>
                                        </tr>
                                    </thead>
                                    {this.renderBody() }
                                </table>
                                <div className="row" style={{ "padding-left": "15px" }} >
                                    <div className="col-md-7">
                                        <div className="form-group" style={{ "padding-left": "50px" }} >
                                            <label className="title1" for="comment">یادداشت</label>
                                            <textarea
                                                name="note"
                                                value={this.state.data.record.note}
                                                onChange={this.handleChange}
                                                className="form-control ng-pristine ng-untouched" rows="4" maxlength="250"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="row text-left bg-info" style={{ "border-bottom": "1px solid rgb(69, 69, 69)", "padding-top": "8px" }} >
                                            <div className="col-lg-6 h5 txt-bold text-right">مجموع <span style={{ "font-weight": "normal" }} > ({this.state.data.global.company.currencyUnit})</span></div>
                                            <div className="col-lg-3 h5 txt-bold" id="documentTotalBed" style={{ "text-align": "center", "width": "120px", "padding": "0" }}>{this.money(this.state.t_bed)}</div>
                                            <div className="col-lg-3 h5 txt-bold" id="documentTotalBes" style={{ "text-align": "center", "width": "120px", "padding": "0" }}>{this.money(this.state.t_bes)}</div>
                                        </div >
                                        <div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
                                        <div className="row text-left" id="documentDeffShow">
                                            <div className="col-lg-4 title1 text-right">اختلاف <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
                                            <div className="col-lg-8 title1 text-center">{this.money(this.state.t_bed - this.state.t_bes)}</div>
                                        </div>
                                    </div>
                                </div>

                                {this.state.data.record.id !== this.getDefaultGuid() && <div>
                                    <WorkFlowStepLogging Caller={this} EntityId={this.state.data.record.id} WorkFlowStepId={this.state.data.record.workFlowStepId} Type={3} />
                                </div>}
                            </div>
                            <div className="modal-footer">
                                {this.state.data.record.id !== this.defaultGuid() && !this.state.isTemplate && !this.isNull(this.state.data.nextDocumentId) && <a className="btn btn-warning me-2" onClick={e => this.nextDocument()} >سند بعدی</a>}
                                {this.state.data.record.id !== this.defaultGuid() && !this.state.isTemplate && !this.isNull(this.state.data.previewsDocumentId) && <a className="btn btn-warning me-2" onClick={e => this.previewsDocument()} >سند قبلی</a>}
                                <button type="button" className="btn btn-primary" onClick={e => this.save(e,false)}>ذخیره - بستن</button>
                                <button type="button" className="btn btn-primary" onClick={e => this.save(e,true)}>ذخیره - ماندن</button>
                                {this.state.data.record.id !== this.defaultGuid() && [
                                    !this.state.isTemplate && <a className="hand btn btn-warning me-2" onClick={e => this.getPdf(this.state.data.record.id)}>PDF</a>
                                ]
                                }
                                {this.state.data.factors.map(factor =>
                                    <a className="hand btn btn-danger me-2" onClick={e => this.showFactor(factor.id, factor.type)}>مشاهده فاکتور {factor.number}</a>
                                )}
                                {this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id)} >حذف سند</a>}
                                <a className="btn btn-warning" onClick={e => this.closeMe()} > انصراف</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}